import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, toJS } from 'mobx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Spinner from '../../../Spinner';
import Form, { FormBody, TextInput } from '../../../Form';
import { BASE_URL } from '../../../../config';
import { getDisplayDate } from '../../../../libs/date';
import ReactModal from 'react-modal';
import ImageSlider from '../../../ImageSlider';
import Button from '../../../Form/Button';
@inject('stationStore', 'surveyStore', 'surveyTopicStore', 'surveyTemplateStore', 'userStore', 'ticketStore', 'workOrderStore', 'reportingTemplateStore')
@observer
class SurveyView extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable item = {
    date_visited: '',
    station_id: '',
    survey_template_id: '',
    visitor_user_id: '',
    ticket_id: '',
    work_order_id: '',
    responses: [],
    images: [],
  };
  @observable selectedImage = 0;
  @observable showFullScreen = false;
  @observable downloading = false;

  componentWillMount() {
    const { stationStore, surveyStore, surveyTemplateStore, surveyTopicStore, userStore, ticketStore, workOrderStore, params: { id } } = this.props;
    if (!stationStore.isLoading && !stationStore.items.length) stationStore.fetchItems();
    if (!surveyTemplateStore.isLoading && !surveyTemplateStore.items.length) surveyTemplateStore.fetchItems();
    if (!surveyTopicStore.isLoading && !surveyTopicStore.items.length) surveyTopicStore.fetchItems();
    if (!userStore.isLoading && !userStore.items.length) userStore.fetchItems();
    if (!ticketStore.isLoading && !ticketStore.items.length) ticketStore.fetchItems();
    if (!workOrderStore.isLoading && !workOrderStore.items.length) workOrderStore.fetchItems();

    this.reset(id)
  }

  reset = (id) => {
    const { surveyStore } = this.props;
    let item = surveyStore.findById(id);
    if (!!item) {
      this.item = item;
    } else {
      surveyStore.fetchItem(id).then(res => {
        if (!!res && !!res[0]) this.item = res[0];
      });
    }
  }

  _renderSurveyQuestionare = () => {
    const { surveyTopicStore, surveyTemplateStore, stationStore, ticketStore } = this.props;
    const template = surveyTemplateStore.findById(this.item.survey_template_id);
    if (!template) return;
    return (
      <div className='bordered side-table' style={{ width: 'calc(100% - 8px)' }}>
        <div className='DataTable'>
          <table>
            <tbody>
              <tr><th><b>Station Name</b></th><td>{this.resolveFromStore(stationStore, this.item.station_id)}</td></tr>
              <tr><th><b>Date Visited</b></th><td>{this.item.date_visited.split('T')[0]}</td></tr>
              <tr><th><b>Ticket Creation Date</b></th>
                {this.item.ticket_id &&
                  <td>{getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'generated_date'))}</td>
                }
              </tr>
              <tr><th><b>Ticket End Date</b></th>
                {this.item.ticket_id &&
                  <td>{this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date') ? getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date')) : '-'} </td>
                }
              </tr>
              {template.topics.sort((a, b) => a.seq < b.seq ? -1 : 1).map(({ topic_id }) => {
                const item = this.item.responses.find(res => res.topic_id === topic_id);
                const topic = surveyTopicStore.findById(topic_id);
                const response = !item ? '-' : surveyTopicStore.resolveValue(topic_id, item.value)
                return (
                  <tr key={`topic-${topic_id}`} >
                    <th><b>{topic.name}</b></th>
                    <td>{response}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  _renderImages = () => {
    let selectedImage = this.item.images[this.selectedImage];
    return <div className='survey-image-container'>
      <div className='station-image-slider'>
        {this.item.images.length > 1 && <div className='station-image-slide-selector'>
          {this.item.images.map((image, i) => (
            <div key={i} className={`image-slide-item ${this.selectedImage === i ? 'image-slide-active' : ''}`} onClick={() => this.selectedImage = i} >
              {/* <img id={image.name} src={`${BASE_URL}/images/${image.name}`} style={{ width: '100%' }} alt='not-found' /> */}
              <div style={{
                height: '100px',
                width: '100px',
                backgroundImage: `url(${BASE_URL}/idaq-files/${image.file_location}/${image.file_name})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '12px',
              }} alt='not-found' />
            </div>
          ))}
        </div>}
        {this.item.images.length > 0 && <div className="imageContainer full-width">
          <div className='imageExpand'>
            <span className='fa fa-expand' onClick={() => this.showFullScreen = true} />
          </div>
          <img src={`${BASE_URL}/idaq-files/${selectedImage.file_location}/${selectedImage.file_name}`} style={{ width: '100%' }} alt='not-found' />
        </div>}
      </div>
    </div>
  }

  _renderImageFullScreen = () => {
    const styles = {
      modal: {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
        },
        content: {
          backgroundColor: 'transparent',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          overflow: 'hidden',
        },
      },
    };

    return <ReactModal
      isOpen
      onRequestClose={() => this.showFullScreen = false}
      style={styles.modal}
    >
      <div>
        <span
          style={{ position: 'absolute', top: '10px', right: '20px', fontSize: 'x-large' }}
          className="fa fa-remove"
          onClick={() => this.showFullScreen = false}
        />
        <ImageSlider
          baseUrl={`${BASE_URL}/idaq-files`}
          images={this.item.images.map((image) => {
            return {
              ...image,
              source: `${image.file_location}/${image.file_name}`,
            }
          })}
          onChangeImage={(image, newIndex) => {
            this.selectedImage = newIndex;
          }}
          noSlider={true}
          play={false}
          width={'80vw'}
          height={'90vh'}
          selectedIndex={this.selectedImage}
        />
      </div>
    </ReactModal>
  }

  resolveFromStore = (store, id, identifier = 'name') => {
    const item = store.findById(id);
    if (!item) return '-';
    return item[identifier]
  }

  download = async (e) => {
    this.downloading = true;

    function getDataUri(url) {
      return new Promise((resolve) => {
        let image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');

        image.onload = function () {
          let canvas = document.createElement('canvas');
          canvas.width = this.naturalWidth;
          canvas.height = this.naturalHeight;

          //next three lines for white background in case png has a transparent background
          let ctx = canvas.getContext('2d');
          ctx.fillStyle = '#fff';  /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          canvas.getContext('2d').drawImage(this, 0, 0);
          resolve(canvas.toDataURL('image/jpeg'));
        };
        image.src = url;
      })
    }

    const imageUriFetch = (this.item.images || []).map(image => getDataUri(`${BASE_URL}/idaq-files/${image.file_location}/${image.file_name}`));

    const { surveyTopicStore, surveyTemplateStore, stationStore, ticketStore, reportingTemplateStore } = this.props;
    const template = surveyTemplateStore.findById(this.item.survey_template_id);
    if (!template) return;

    const csv = ['']
    csv.push(['Station Name', this.resolveFromStore(stationStore, this.item.station_id)].join(','));
    csv.push(['Date Visited', this.item.date_visited.split('T')[0]].join(','));
    if (this.item.ticket_id) {
      csv.push(['Ticket Creation Date', getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'generated_date'))].join(','));
      csv.push(['Ticket End Date', this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date') ? getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date')) : '-'].join(','));
    }

    template.topics.sort((a, b) => a.seq < b.seq ? -1 : 1).map(({ topic_id }) => {
      const item = this.item.responses.find(res => res.topic_id === topic_id);
      const topic = surveyTopicStore.findById(topic_id);
      let response = !item ? '-' : surveyTopicStore.resolveValue(topic_id, item.value)

      if (typeof response == 'string' && response.includes(',')) {
        response = `"${response}"`; 
      }
      csv.push([topic.name, response].join(','));
    })

    let fileName = `${this.resolveFromStore(surveyTemplateStore, this.item.survey_template_id)} ${this.resolveFromStore(stationStore, this.item.station_id)}`.split(' ').join('_').replace(/\./g, '_');

    Promise.all(imageUriFetch)
      .then(images => {
        return reportingTemplateStore.downloadReport(
          csv.join('\n'),
          'pdf',
          { orientation: 'Portrait', report_name: template.name, images, columnStyles: { fontStyle: 'bold' }, noHeader: true },
          fileName
        );

      }).then(() => this.downloading = false);
  }

  render() {
    const { stationStore, surveyTemplateStore, surveyTopicStore, userStore, ticketStore, workOrderStore } = this.props;

    let isLoading = surveyTemplateStore.isLoading || stationStore.isLoading || surveyTopicStore.isLoading || userStore.isLoading || ticketStore.isLoading || workOrderStore.isLoading;
    if (isLoading) return <Spinner />;

    if (this.showFullScreen) return this._renderImageFullScreen();

    return (
      <div>
        <div className='inline-grid overflow-x-hidden'>
          <div className='flex-grow'>
            <Form>
              <FormBody>
                <div className='inline-grid'>
                  <div>
                    <div className='formInput'>
                      <label>Station Name</label>
                      <a href={`#/station/${this.item.station_id}/monitoring`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}>{this.resolveFromStore(stationStore, this.item.station_id)}</a>
                    </div>
                    <TextInput label={'Visited By'} value={this.resolveFromStore(userStore, this.item.visitor_user_id)} readOnly />
                    <TextInput label={'Date Visited'} value={this.item.date_visited} readOnly />
                    <TextInput label={'Survey Template'} value={this.resolveFromStore(surveyTemplateStore, this.item.survey_template_id)} readOnly />
                    <TextInput label={'Date Created'} value={this.item.date_created} readOnly />
                  </div>
                  <div>
                    {!this.item.ticket_id ?
                      <TextInput label={'Ticket'} value={this.resolveFromStore(ticketStore, this.item.ticket_id, 'summary')} readOnly /> :
                      <div className='formInput'>
                        <label>Ticket</label>
                        <a href={`#/monitoring/ticket/tabular/${this.item.ticket_id}/view`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}>{this.resolveFromStore(ticketStore, this.item.ticket_id, 'summary')}</a>
                      </div>}
                    {this.item.ticket_id &&
                      <TextInput label={'Ticket Creation Date'} value={getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'generated_date'))} readOnly />
                    }
                    {this.item.ticket_id &&
                      <TextInput label={'Ticket End Date'} value={this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date') ? getDisplayDate(this.resolveFromStore(ticketStore, this.item.ticket_id, 'end_date')) : '-'} readOnly />
                    }
                    {!this.item.work_order_id ?
                      <TextInput label={'Work Order'} value={this.resolveFromStore(workOrderStore, this.item.work_order_id, 'title')} readOnly /> :
                      <div className='formInput'>
                        <label>Work Order</label>
                        <a href={`#/monitoring/work_order/tabular/${this.item.work_order_id}/view`} target='_blank' className={'button button-inactive'} style={{ maxWidth: '230px', margin: 0, fontSize: '14px' }}>{this.resolveFromStore(workOrderStore, this.item.work_order_id, 'title')}</a>
                      </div>}
                    <TextInput label={'Created By'} value={this.resolveFromStore(userStore, this.item.creator_user_id)} readOnly />
                  </div>
                </div><br />
              </FormBody>
            </Form>
            {this._renderSurveyQuestionare(this.item.survey_template_id)}
            <br />
            <Button label='Download' onClick={this.download} isLoading={this.downloading} />
          </div>
          {!!this.item.images && !!this.item.images.length && this._renderImages()}
        </div>
      </div>
    );
  }
}

export default SurveyView;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/Survey/SurveyView.js